import { PROFESSIONAL_CODING_OPTIONS } from "../scenes/FacilityPreferences/models/preferences";

import type { ProfessionalCodingType } from "../scenes/FacilityPreferences/models/preferences";

/**
 * Determines the default AllowProfessionalCoding value based on facility settings
 * Used when initializing users or when roles change from NoRole
 * @param facilityProFeePolicy - The facility's professional coding policy
 * @returns The default value for AllowProfessionalCoding
 */
export const getDefaultProFeeValue = (facilityProFeePolicy?: ProfessionalCodingType): boolean => {
  // If facility setting is "For Individual Users", default to checked (true)
  // If facility setting is "For All Users", it will be checked and disabled (handled in UI)
  // If facility setting is "None", it will be unchecked and disabled (handled in UI)
  if (facilityProFeePolicy === PROFESSIONAL_CODING_OPTIONS.ForIndividualUsers) {
    return true;
  }

  if (facilityProFeePolicy === PROFESSIONAL_CODING_OPTIONS.ForAllUsers) {
    return true;
  }

  // For "None" or undefined, default to false
  return false;
};

/**
 * Determines if a role should have Professional Coding access
 * @param role - The user's role
 * @param isSystemAdmin - Whether the user is a system admin
 * @param isItAdmin - Whether the user is an IT admin
 * @returns Whether the role should have access to Professional Coding
 */
export const shouldRoleHaveProFeeAccess = (
  role: string,
  isSystemAdmin = false,
  isItAdmin = false,
): boolean => {
  // NoRole should not have ProFee access
  if (role === "NoRole") {
    return false;
  }

  // IT Security Admin alone should not have ProFee access
  if (isItAdmin && !isSystemAdmin) {
    return false;
  }

  // All other roles can have ProFee access based on facility settings
  return true;
};
